import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useLocation, Link, useParams } from 'react-router-dom';
import { Tab, Nav } from 'react-bootstrap';
import '../transaction/imageview.css';

const $ = require("jquery");
$.Datatable = require("datatables.net");

export default function View() {
    const { id } = useParams();
    const [user, setUser] = useState(null);
    const [challenge, setChallenge] = useState([]);
    const [txn, setTxn] = useState([]);
    const [txnwith, setTxnwith] = useState([]);
    const [referral, setReferral] = useState([]);
    const [kyc, setKyc] = useState(null);
    const [referCount, setReferCount] = useState([]);
    const [mismatchValue, setMismatchValue] = useState(0);
    const [holdBalance, setHoldBalance] = useState(0);
    const [activeTab, setActiveTab] = useState('challenges');

    const backendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
    const backendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
    const frontendLocalUrl = process.env.REACT_APP_FRONTEND_LOCAL_API;
    const frontendLiveUrl = process.env.REACT_APP_FRONTEND_LIVE_API;
    const nodeMode = process.env.NODE_ENV;
    const baseUrl = nodeMode === "development" ? backendLocalApiUrl : backendLiveApiUrl;
    const frontendUrl = nodeMode === "development" ? frontendLocalUrl : frontendLiveUrl;

    useEffect(() => {
        const access_token = localStorage.getItem("token");
        const headers = { Authorization: `Bearer ${access_token}` };

        axios.get(baseUrl + `get_user/${id}`, { headers })
            .then((res) => {
                const userData = res.data;
                setUser(userData);
                setMismatchValue(userData.Wallet_balance - (((userData.wonAmount - userData.loseAmount) + userData.totalDeposit + userData.referral_earning + userData.totalBonus) - (userData.totalWithdrawl + userData.referral_wallet + userData.withdraw_holdbalance + userData.hold_balance + userData.totalPenalty)));
                setHoldBalance(userData.hold_balance);
                if (userData.referral_code) {
                    Allrefer(userData.referral_code);
                }
            })
            .catch((e) => console.log(e));
    }, [id, baseUrl]);

    // Fetch challenges on initial load (onSelect doesn't fire for defaultActiveKey)
    useEffect(() => {
        if (!id || !baseUrl) return;
        const access_token = localStorage.getItem("token");
        const headers = { Authorization: `Bearer ${access_token}` };
        axios.get(baseUrl + `get_challange/user/${id}`, { headers })
            .then((res) => {
                setChallenge(res.data);
                setActiveTab('challenges');
            })
            .catch((e) => console.log(e));
    }, [id, baseUrl]);




    const Allrefer = async (referralCode) => {
        const access_token = localStorage.getItem("token");
        const headers = { Authorization: `Bearer ${access_token}` };
        try {
            const res = await axios.get(baseUrl + `referral/code/${referralCode}`, { headers });
            setReferCount(res.data);
        } catch (e) {
            console.log(e);
        }
    };

    const fetchData = async (type) => {
        const access_token = localStorage.getItem("token");
        const headers = { Authorization: `Bearer ${access_token}` };
        let url = '';
        let setData;

        switch (type) {
            case 'challenges':
                url = baseUrl + `get_challange/user/${id}`;
                setData = setChallenge;
                break;
            case 'transactions':
                url = baseUrl + `txn_history/user/${id}`;
                setData = setTxn;
                break;

            case 'withdrawals':
                url = baseUrl + `txnwith_history/user/${id}`;
                setData = setTxnwith;
                break;
            case 'referrals':
                if (user && user.referral_code) {
                    url = baseUrl + `referral/code/winn/${user.referral_code}`;
                    setData = setReferral;
                }
                break;
            case 'kyc':
                url = baseUrl + `admin/user/kyc/${id}`;
                setData = setKyc;
                break;
            default:
                return;
        }
        if (!url) return;

        try {
            const res = await axios.get(url, { headers });
            // Clear all states first, then set only the relevant one
            setChallenge([]);
            setTxn([]);
            setTxnwith([]);
            setReferral([]);
            setKyc(null);
            setActiveTab(type);
            setData(res.data);
        } catch (e) {
            console.log(e);
        }
    };
    const dateFormat = (e) => {
        const date = new Date(e);
        return date.toLocaleString('default', { month: 'long', day: 'numeric', hour: 'numeric', hour12: true, minute: 'numeric' });
    };

    const updateKycStatus = (Id, type) => {
        const access_token = localStorage.getItem("token");
        const headers = { Authorization: `Bearer ${access_token}` };
        axios.patch(baseUrl + `${type}/${Id}`, { verified: "verified" }, { headers })
            .then(() => fetchData('kyc'))
            .catch(e => console.log(e));
    };

    const updateBalance = (action) => {
        const access_token = localStorage.getItem("token");
        const headers = { Authorization: `Bearer ${access_token}` };
        axios.patch(baseUrl + `user/${action}/clear/${id}`, {}, { headers })
            .then(() => {
                axios.get(baseUrl + `get_user/${id}`, { headers })
                    .then((res) => {
                        const userData = res.data;
                        setUser(userData);
                        setMismatchValue(userData.Wallet_balance - (((userData.wonAmount - userData.loseAmount) + userData.totalDeposit + userData.referral_earning + userData.totalBonus) - (userData.totalWithdrawl + userData.referral_wallet + userData.withdraw_holdbalance + userData.hold_balance + userData.totalPenalty)));
                        setHoldBalance(userData.hold_balance);
                    });
            })
            .catch(e => console.log(e));
    };

    if (!user) {
        return <div className="text-center mt-5"><h4>Loading...</h4></div>;
    }

    const renderTable = () => {
        let headers = [];
        let data = [];

        if (activeTab === 'challenges') {
            return (
                <div className="table-responsive">
                    <table className="table table-dark table-striped text-light" style={{ verticalAlign: 'middle' }}>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>ID</th>
                                <th>Creator</th>
                                <th>Accepter</th>
                                <th>Amount</th>
                                <th>Status</th>
                                <th>Game Type</th>
                                <th>Winner</th>
                                <th>Date</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {challenge && challenge.map((item, index) => {
                                let statusColorClass = 'text-info';
                                if (item.Status === 'completed') statusColorClass = 'text-success';
                                else if (item.Status === 'cancelled' || item.Status === 'drop') statusColorClass = 'text-danger';

                                return (
                                    <tr key={item._id || index}>
                                        <td>{index + 1}</td>
                                        <td><small style={{ fontFamily: 'monospace' }}>{item._id}</small></td>
                                        <td>{item.Created_by?.Name || '—'}</td>
                                        <td>{item.Accepted_By?.Name || '—'}</td>
                                        <td>{item.Game_Ammount}</td>
                                        <td>
                                            <strong className={statusColorClass}>{item.Status}</strong>
                                        </td>
                                        <td>{item.Game_type}</td>
                                        <td>{item.Winner?.Name || '—'}</td>
                                        <td>{dateFormat(item.createdAt)}</td>
                                        <td>
                                            <Link to={`/view/${item._id}`} className="btn btn-danger btn-sm text-uppercase font-weight-bold" style={{ borderRadius: '4px' }}>
                                                View
                                            </Link>
                                        </td>
                                    </tr>
                                );
                            })}
                            {(!challenge || challenge.length === 0) && (
                                <tr>
                                    <td colSpan="10" className="text-center text-muted py-3">No challenges found</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            );
        }

        switch (activeTab) {
            case 'transactions':
                headers = ["#", "Txn ID", "Amount", "Type", "Status", "Date"];
                data = txn;
                break;
            case 'withdrawals':
                headers = ["#", "Txn ID", "Amount", "Status", "Date"];
                data = txnwith;
                break;
            case 'referrals':
                headers = ["#", "User ID", "Amount", "Date"];
                data = referral;
                break;
            case 'kyc':
                return renderKycTable();
            default:
                return null;
        }

        return (
            <div className="table-responsive">
                <table className="table table-dark table-striped">
                    <thead>
                        <tr>
                            {headers.map(h => <th key={h}>{h}</th>)}
                        </tr>
                    </thead>
                    <tbody>
                        {data && data.map((item, index) => (
                            <tr key={item._id || index}>
                                <td>{index + 1}</td>
                                {activeTab === 'transactions' && <><td>{item.Tx_refrance}</td><td>{item.amount}</td><td>{item.type}</td><td><div className={`badge ${item.status === 'success' ? 'badge-success' : 'badge-danger'}`}>{item.status}</div></td><td>{dateFormat(item.createdAt)}</td></>}
                                {activeTab === 'withdrawals' && <><td>{item.txn_id}</td><td>{item.amount}</td><td><div className={`badge ${item.status === 'success' ? 'badge-success' : 'badge-danger'}`}>{item.status}</div></td><td>{dateFormat(item.createdAt)}</td></>}
                                {activeTab === 'referrals' && <><td>{item.referred_by}</td><td>{item.amount}</td><td>{dateFormat(item.createdAt)}</td></>}
                            </tr>
                        ))}
                        {(!data || data.length === 0) && (
                            <tr>
                                <td colSpan={headers.length} className="text-center text-muted py-3">No data found</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        );
    };

    const renderKycTable = () => {
        const aadhar = kyc ? kyc.Aadhar : null;
        const pan = kyc ? kyc.Pan : null;
        const hasKyc = aadhar || pan;

        const renderDoc = (path, alt) => {
            if (!path) return '';
            const fileUrl = path.startsWith('http') ? path : `${baseUrl}${path}`;
            const isPdf = path.toLowerCase().endsWith('.pdf');
            if (isPdf) {
                return (
                    <a href={fileUrl} target="_blank" rel="noopener noreferrer" className="btn btn-danger text-white d-flex align-items-center justify-content-center" style={{ width: '100px', height: '100px', flexDirection: 'column', gap: '5px', textDecoration: 'none', borderRadius: '8px' }}>
                        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                            <polyline points="14 2 14 8 20 8" />
                            <line x1="16" y1="13" x2="8" y2="13" />
                            <line x1="16" y1="17" x2="8" y2="17" />
                        </svg>
                        <span style={{ fontSize: '11px', fontWeight: '700' }}>View PDF</span>
                    </a>
                );
            }
            return <img className="img" src={fileUrl} alt={alt} width="100" />;
        };

        return (
            <div className="table-responsive">
                <table className="table table-dark table-striped">
                    <thead>
                        <tr><th>Document</th><th>Details</th><th>Actions</th></tr>
                    </thead>
                    <tbody>
                        {aadhar &&
                            <tr>
                                <td>Aadhar Card</td>
                                <td>
                                    <p><strong>Number:</strong> {aadhar.Number}</p>
                                    <div className="d-flex">
                                        <div className="img-panel mr-2">{renderDoc(aadhar.front, "Aadhar")}</div>
                                        <div className="img-panel">{renderDoc(aadhar.back, "Aadhar Back")}</div>
                                    </div>
                                </td>
                                <td>
                                    {aadhar.verified !== 'verified' ?
                                        <button className="btn btn-success" onClick={() => updateKycStatus(aadhar._id, 'aadharcard')}>Verify</button> :
                                        <span className="badge badge-success">Verified</span>
                                    }
                                </td>
                            </tr>
                        }
                        {pan &&
                            <tr>
                                <td>PAN Card</td>
                                <td>
                                    <p><strong>Number:</strong> {pan.Number}</p>
                                    <div className="img-panel">{renderDoc(pan.docs, "PAN")}</div>
                                </td>
                                <td>
                                    {pan.verified !== 'verified' ?
                                        <button className="btn btn-success" onClick={() => updateKycStatus(pan._id, 'pancard')}>Verify</button> :
                                        <span className="badge badge-success">Verified</span>
                                    }
                                </td>
                            </tr>
                        }
                        {!hasKyc && (
                            <tr>
                                <td colSpan="3" className="text-center text-muted py-3">No KYC details found</td>
                            </tr>
                        )}
                    </tbody>
                </table>
                <div className="img-out"></div>
            </div>
        );
    };

    return (
        <div className="container-fluid">
            <h4 className='font-weight-bold my-3'>User Details</h4>
            <div className="row">
                <div className="col-md-12">
                    <div className="card text-white" style={{ backgroundColor: "var(--card-bg)" }}>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-2 text-center">
                                    <img src={user.avatar ? (user.avatar.startsWith('http') ? user.avatar : (user.avatar.startsWith('avatar') ? `${frontendUrl}images/avatars/${user.avatar}` : `${baseUrl}${user.avatar}`)) : 'https://cdn-icons-png.flaticon.com/512/149/149071.png'} alt="profile" className="img-lg rounded-circle mb-3" style={{ width: '100px', height: '100px', objectFit: 'cover', border: '3px solid rgba(255, 255, 255, 0.15)' }} />
                                    <h4 className="card-title">{user.Name}</h4>
                                    <p className="text-muted">{user.user_type}</p>
                                </div>
                                <div className="col-md-10">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <p><strong>User ID:</strong> {user._id}</p>
                                            <p><strong>Phone:</strong> {user.Phone}</p>
                                            <p><strong>Email:</strong> {user.Email || 'N/A'}</p>
                                            <p><strong>Created At:</strong> {user.createdAt ? new Date(user.createdAt).toLocaleDateString('default', { year: 'numeric', month: 'long', day: 'numeric' }) : 'N/A'}</p>
                                        </div>
                                        <div className="col-md-4">
                                            <p><strong>Wallet Balance:</strong> <span className="text-success">₹{user.Wallet_balance}</span></p>
                                            <p><strong>Hold Balance:</strong> <span className="text-warning">₹{holdBalance}</span></p>
                                            <p><strong>Mismatch Balance:</strong> <span className="text-danger">₹{mismatchValue}</span></p>
                                            <p><strong>Total Bonus:</strong> <span className="text-info">₹{user.totalBonus || 0}</span></p>
                                            <p><strong>Total Penalty:</strong> <span className="text-danger">₹{user.totalPenalty || 0}</span></p>
                                        </div>
                                        <div className="col-md-4">
                                            <p><strong>Verified:</strong> {user.verified === 'verified' ? <span className="badge badge-success">Yes</span> : <span className="badge badge-danger">No</span>}</p>
                                            <p><strong>Referred By:</strong> {user.referred_by || 'N/A'}</p>
                                            <p><strong>Total Referrals:</strong> {referCount.length}</p>
                                            <p><strong>Total Deposit:</strong> <span className="text-success">₹{user.totalDeposit || 0}</span></p>
                                            <p><strong>Total Withdraw:</strong> <span className="text-warning">₹{user.totalWithdrawl || 0}</span></p>
                                        </div>
                                    </div>
                                    <div className="mt-3 d-flex flex-wrap align-items-center" style={{ gap: '10px' }}>
                                        <Link to={`/user/adduser/${user._id}`} className="btn btn-primary">Edit User</Link>
                                        <button className="btn btn-warning" onClick={() => updateBalance('missmatch')}>Clear Mismatch</button>
                                        <button className="btn btn-info" onClick={() => updateBalance('Hold')}>Clear Hold</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row mt-4">
                <div className="col-md-12">
                    <div className="card text-white" style={{ backgroundColor: "var(--card-bg)" }}>
                        <div className="card-body">
                            <Tab.Container id="user-details-tabs" defaultActiveKey="challenges" onSelect={(k) => fetchData(k)}>
                                <Nav variant="pills" className="mb-3 d-flex flex-row flex-nowrap" style={{ overflowX: 'auto', gap: '10px', paddingBottom: '10px' }}>
                                    <Nav.Item><Nav.Link eventKey="challenges">Challenges</Nav.Link></Nav.Item>
                                    <Nav.Item><Nav.Link eventKey="transactions">Deposit</Nav.Link></Nav.Item>
                                    <Nav.Item><Nav.Link eventKey="withdrawals">Withdrawals</Nav.Link></Nav.Item>
                                    <Nav.Item><Nav.Link eventKey="referrals">Referrals</Nav.Link></Nav.Item>
                                    <Nav.Item><Nav.Link eventKey="kyc">KYC Details</Nav.Link></Nav.Item>
                                </Nav>
                                <Tab.Content>
                                    <Tab.Pane eventKey="challenges">{activeTab === 'challenges' && renderTable()}</Tab.Pane>
                                    <Tab.Pane eventKey="transactions">{activeTab === 'transactions' && renderTable()}</Tab.Pane>
                                    <Tab.Pane eventKey="withdrawals">{activeTab === 'withdrawals' && renderTable()}</Tab.Pane>
                                    <Tab.Pane eventKey="referrals">{activeTab === 'referrals' && renderTable()}</Tab.Pane>
                                    <Tab.Pane eventKey="kyc">{activeTab === 'kyc' && renderTable()}</Tab.Pane>
                                </Tab.Content>
                            </Tab.Container>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
